// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__S3HYV","resendInfoText":"OnGoingPaymentBox_resendInfoText__2CqI8"};